module.exports = __webpack_public_path__ + "img/setup-cost-success.4e255228.png";